export default "/images/0f4c18fd97cb7bafc91cd227c292f887.avif";